var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.debugging ? 'outline: 2px solid green;' : '')},[_c('canvas',{ref:"canvas",style:(_vm.debugging ? 'box-shadow: inset 0 0 0 2px red;' : ''),attrs:{"width":"400","height":"400"}})])}
var staticRenderFns = []

export { render, staticRenderFns }